(function(){
  if(window.__DT_CART_LIVE_UI_V5__) return;
  window.__DT_CART_LIVE_UI_V5__=true;

  var syncTimer=null,syncBusy=false,syncAgain=false,workingTimer=null,workingHost=null,rewardTimer=null;
  var STATE_TTL=15000;

  function validCart(c){return !!(c&&Array.isArray(c.items)&&typeof c.item_count==='number')}
  function rememberCart(c){
    if(!validCart(c)) return null;
    window.__DT_ELMORE_CART_STATE__=c;
    window.__DT_ELMORE_CART_STATE_AT__=Date.now();
    paintCount(c.item_count,true);
    return c;
  }
  function sharedCart(){
    var c=window.__DT_ELMORE_CART_STATE__,at=Number(window.__DT_ELMORE_CART_STATE_AT__||0);
    return validCart(c)&&Date.now()-at<STATE_TTL?c:null;
  }
  function cartFromSection(html){
    if(!html)return null;
    try{
      var doc=new DOMParser().parseFromString(html,'text/html');
      var el=doc.querySelector('[data-dt-cart-snapshot]');
      var c=el&&JSON.parse(el.textContent||'{}');
      return validCart(c)?c:null;
    }catch(e){return null}
  }
  function cartFromMutationData(data){
    if(!data)return null;
    var html=data.sections&&data.sections['cart-drawer-section'];
    var c=cartFromSection(html);
    if(c)return c;
    if(validCart(data))return data;
    return null;
  }

  function requestInfo(input,init){
    try{
      var method=String((init&&init.method)||(input&&input.method)||'GET').toUpperCase();
      var raw=typeof input==='string'?input:(input&&input.url)||'';
      var u=new URL(raw,location.origin);
      return{method:method,url:u,same:u.origin===location.origin};
    }catch(e){return null}
  }
  function cartMutation(info){return !!(info&&info.same&&info.method!=='GET'&&info.method!=='HEAD'&&/\/cart\/(add|change|update|clear)\.js$/i.test(info.url.pathname))}
  function cartRead(info){return !!(info&&info.same&&info.method==='GET'&&/\/cart\.js$/i.test(info.url.pathname))}

  function paintStandaloneBubble(bubble,count){
    if(!bubble)return;
    var countEl=bubble.querySelector('[ref="cartBubbleCount"],.cart-bubble__text-count');
    bubble.classList.toggle('visually-hidden',count===0);
    if(countEl){countEl.classList.toggle('hidden',count===0);countEl.textContent=count<100?String(count):''}
    if(count<=99)bubble.setAttribute('data-maintain-ratio','');else bubble.removeAttribute('data-maintain-ratio');
  }
  function paintCount(count,animate){
    count=Math.max(0,Number(count)||0);
    document.querySelectorAll('cart-icon').forEach(function(el){try{if(typeof el.renderCartBubble==='function')el.renderCartBubble(count,animate!==false)}catch(e){}});
    document.querySelectorAll('.cart-bubble').forEach(function(bubble){if(!bubble.closest('cart-icon'))paintStandaloneBubble(bubble,count)});
    try{sessionStorage.setItem('cart-count',JSON.stringify({value:String(count<100?count:''),timestamp:Date.now()}))}catch(e){}
  }

  async function syncNow(){
    if(syncBusy){syncAgain=true;return}
    syncBusy=true;
    try{
      var r=await window.__DT_CART_NATIVE_FETCH__('/cart.js?dt_live_count='+Date.now(),{credentials:'same-origin',headers:{Accept:'application/json'},cache:'no-store'});
      if(r.ok){var c=await r.json();rememberCart(c)}
    }catch(e){console.warn('[DT cart live] count refresh failed',e)}
    finally{syncBusy=false;if(syncAgain){syncAgain=false;queueSync(30)}}
  }
  function queueSync(delay){clearTimeout(syncTimer);syncTimer=setTimeout(syncNow,delay==null?35:delay)}

  if(!window.__DT_CART_NATIVE_FETCH__)window.__DT_CART_NATIVE_FETCH__=window.fetch.bind(window);
  var nativeFetch=window.__DT_CART_NATIVE_FETCH__;
  window.fetch=function(input,init){
    var info=requestInfo(input,init),cached=null; // Always fetch authoritative cart; BOGOS gifts settle asynchronously.
    if(cached){
      return Promise.resolve(new Response(JSON.stringify(cached),{status:200,headers:{'Content-Type':'application/json','Cache-Control':'no-store'}}));
    }
    var p=nativeFetch(input,init);
    if(!cartMutation(info))return p;
    return p.then(async function(r){
      if(!r||!r.ok)return r;
      var captured=null;
      try{
        var data=await r.clone().json();
        captured=rememberCart(cartFromMutationData(data));
      }catch(e){}
      if(!captured)queueSync(0);
      return r;
    });
  };

  function norm(v){return String(v||'').trim().toLowerCase().replace(/[_-]+/g,' ').replace(/\s+/g,' ')}
  function rewardRow(row){
    if(!row)return false;
    var d=row.dataset||{};
    var vals=[d.dtmLine,d.dtDealLine,d.elmoreBundleRole,d.elmoreRole,d.dtmV15Role,d.dtmV9Role];
    for(var i=0;i<vals.length;i++){
      var r=norm(vals[i]);
      if(r==='reward'||r==='reward item'||r==='bundle item')return true;
    }
    var t=norm(row.textContent||'');
    return t.indexOf('elmore deal role: reward item')>-1||t.indexOf('deal role: reward item')>-1;
  }
  function hideRewardControl(el){
    if(!el)return;
    try{el.style.setProperty('display','none','important')}catch(e){}
    try{el.hidden=true;el.disabled=true;el.setAttribute('aria-hidden','true');el.tabIndex=-1}catch(e){}
  }
  function lockRewardRows(){
    document.querySelectorAll('#cart-drawer .cart-items__table-row,#cart-drawer tr[data-key]').forEach(function(row){
      if(!rewardRow(row))return;
      row.setAttribute('data-elmore-reward-locked','1');
      row.querySelectorAll('.cart-items__remove,.quantity-plus,.quantity-minus,button[name="plus"],button[name="minus"],[data-quantity-plus],[data-quantity-minus],button[onclick*="onLineItemRemove"],cart-quantity-selector-component button,.quantity-selector button').forEach(hideRewardControl);
      row.querySelectorAll('input[type="number"],input[name*="updates"]').forEach(function(inp){
        inp.readOnly=true;inp.tabIndex=-1;inp.style.pointerEvents='none';inp.setAttribute('aria-readonly','true');
      });
    });
  }
  function queueRewardLock(delay){clearTimeout(rewardTimer);rewardTimer=setTimeout(lockRewardRows,delay==null?0:delay)}
  function rewardControlTarget(target){
    return target&&target.closest&&target.closest('.cart-items__remove,.quantity-plus,.quantity-minus,button[name="plus"],button[name="minus"],[data-quantity-plus],[data-quantity-minus],cart-quantity-selector-component button,.quantity-selector button');
  }
  window.addEventListener('click',function(e){
    var ctl=rewardControlTarget(e.target);if(!ctl)return;
    var row=ctl.closest('.cart-items__table-row,tr[data-key]');
    if(rewardRow(row)){e.preventDefault();e.stopImmediatePropagation()}
  },true);
  window.addEventListener('change',function(e){
    var inp=e.target&&e.target.closest&&e.target.closest('#cart-drawer input[type="number"],#cart-drawer input[name*="updates"]');if(!inp)return;
    var row=inp.closest('.cart-items__table-row,tr[data-key]');
    if(rewardRow(row)){e.preventDefault();e.stopImmediatePropagation()}
  },true);

  function mainBundleRow(row){
    if(!row)return false;
    var role=String((row.dataset&&(row.dataset.dtmLine||row.dataset.dtDealLine||row.dataset.elmoreBundleRole))||'').trim().toLowerCase();
    if(role==='qualifier'||role==='main'||role==='main product')return true;
    return String(row.textContent||'').toLowerCase().indexOf('deal role: main product')>-1;
  }
  function removeWorking(){
    clearTimeout(workingTimer);workingTimer=null;
    document.querySelectorAll('.dt-cart-working').forEach(function(el){el.remove()});
    if(workingHost){try{workingHost.classList.remove('dt-cart-working-host')}catch(e){}workingHost=null}
  }
  function showWorking(){
    var drawer=document.querySelector('#cart-drawer');
    var host=drawer&&(drawer.querySelector('.cart-drawer__inner')||drawer.querySelector('.theme-drawer__dialog'));
    if(!drawer||!host||host.querySelector('.dt-cart-working'))return;
    workingHost=host;host.classList.add('dt-cart-working-host');
    var overlay=document.createElement('div');
    overlay.className='dt-cart-working';overlay.setAttribute('role','status');overlay.setAttribute('aria-live','polite');
    overlay.innerHTML='<div class="dt-cart-working__card"><span class="dt-cart-working__spinner" aria-hidden="true"></span><div><strong>Updating your bag…</strong><small>Removing this bundle safely. Please wait.</small></div></div>';
    host.appendChild(overlay);clearTimeout(workingTimer);workingTimer=setTimeout(removeWorking,9000);
  }
  function maybeRemoving(target){
    var b=target&&target.closest&&target.closest('#cart-drawer .cart-items__remove');if(!b)return;
    var row=b.closest('.cart-items__table-row,tr[data-key]');if(mainBundleRow(row))showWorking();
  }
  window.addEventListener('click',function(e){maybeRemoving(e.target)},true);

  function rememberCheckoutLabel(target){
    var btn=target&&target.closest&&target.closest('#checkout,button[name="checkout"]');if(!btn)return;
    var txt=String(btn.textContent||'').trim();
    if(txt&&!/preparing secure checkout/i.test(txt)){
      btn.dataset.elmoreCheckoutLabel=txt;
      try{sessionStorage.setItem('elmore:last-checkout-label',txt)}catch(e){}
    }
  }
  window.addEventListener('pointerdown',function(e){rememberCheckoutLabel(e.target)},true);
  window.addEventListener('click',function(e){rememberCheckoutLabel(e.target)},true);

  function resetTransientCheckoutUi(){
    removeWorking();
    var drawer=document.querySelector('#cart-drawer');
    var wasBusy=!!(drawer&&drawer.classList.contains('dtm-is-busy'));
    if(drawer){drawer.classList.remove('dtm-is-busy');drawer.removeAttribute('aria-busy')}
    document.documentElement.classList.remove('elmore-bundle-syncing');
    document.querySelectorAll('#checkout,button[name="checkout"]').forEach(function(btn){
      var txt=String(btn.textContent||'').trim();
      if(wasBusy||/preparing secure checkout/i.test(txt)){
        var label=btn.dataset.elmoreCheckoutLabel||'';
        if(!label){try{label=sessionStorage.getItem('elmore:last-checkout-label')||''}catch(e){}}
        btn.disabled=false;
        if(/preparing secure checkout/i.test(txt))btn.textContent=label||'Checkout';
      }
    });
    queueRewardLock(0);
  }

  window.addEventListener('pageshow',function(){
    resetTransientCheckoutUi();
    requestAnimationFrame(resetTransientCheckoutUi);
    setTimeout(resetTransientCheckoutUi,80);
    setTimeout(resetTransientCheckoutUi,300);
    queueSync(20);
  });
  document.addEventListener('visibilitychange',function(){if(document.visibilityState==='visible')setTimeout(resetTransientCheckoutUi,30)});
  window.addEventListener('elmore:bundle-cart-added',function(e){removeWorking();var c=e&&e.detail&&e.detail.cart;if(c)rememberCart(c);else if(!sharedCart())queueSync(0);queueRewardLock(0)});
  document.addEventListener('cart:refresh',function(){removeWorking();if(!sharedCart())queueSync(0);queueRewardLock(0)});

  var observer=new MutationObserver(function(muts){
    for(var i=0;i<muts.length;i++){
      if(muts[i].type==='childList'&&muts[i].addedNodes&&muts[i].addedNodes.length){queueRewardLock(15);break}
    }
  });
  if(document.documentElement)observer.observe(document.documentElement,{childList:true,subtree:true});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){queueRewardLock(0);resetTransientCheckoutUi()});else{queueRewardLock(0);resetTransientCheckoutUi()}

  var style=document.createElement('style');
  style.textContent='#cart-drawer [data-elmore-reward-locked="1"] .cart-items__remove,#cart-drawer [data-elmore-reward-locked="1"] .quantity-plus,#cart-drawer [data-elmore-reward-locked="1"] .quantity-minus,#cart-drawer [data-elmore-reward-locked="1"] button[name="plus"],#cart-drawer [data-elmore-reward-locked="1"] button[name="minus"],#cart-drawer [data-elmore-reward-locked="1"] [data-quantity-plus],#cart-drawer [data-elmore-reward-locked="1"] [data-quantity-minus],#cart-drawer [data-elmore-reward-locked="1"] cart-quantity-selector-component button,#cart-drawer [data-elmore-reward-locked="1"] .quantity-selector button{display:none!important}.dt-cart-working-host{position:relative}.dt-cart-working{position:absolute;inset:0;z-index:100;display:grid;place-items:center;padding:20px;background:rgb(var(--color-background-rgb,255 255 255)/.72);backdrop-filter:blur(3px);-webkit-backdrop-filter:blur(3px);cursor:wait}.dt-cart-working__card{display:flex;align-items:center;gap:12px;width:min(330px,calc(100% - 28px));padding:16px 17px;border:1px solid rgb(var(--color-foreground-rgb,30 30 30)/.12);border-radius:var(--style-border-radius-popover,16px);background:var(--color-background,#fff);color:var(--color-foreground,#222);box-shadow:var(--shadow-popover,0 12px 35px rgba(0,0,0,.12))}.dt-cart-working__card>div{display:grid;gap:3px}.dt-cart-working__card strong{font-size:.86rem;line-height:1.25;font-weight:700}.dt-cart-working__card small{font-size:.68rem;line-height:1.4;opacity:.68}.dt-cart-working__spinner{width:22px;height:22px;flex:0 0 22px;border:2px solid currentColor;border-right-color:transparent;border-radius:50%;opacity:.65;animation:dtCartSpin .7s linear infinite}@keyframes dtCartSpin{to{transform:rotate(360deg)}}';
  document.head.appendChild(style);
})();